// js/common/pin.js
import { gsap, ScrollTrigger } from "./gsap";

/**
 * 安全・再利用可能な pin 生成
 * - 同一IDがあれば kill してから作成
 * - markers/pinSpacing をオプションで制御可能
 */
export const setupPinnedSection = (
  sectionSelector,
  containerSelector,
  pinSelector,
  {
    pinSpacing = false,
    markers = false,
    id,
  } = {}
) => {
  const container = document.querySelector(containerSelector);
  const section   = container?.closest(sectionSelector) || container;
  if (!container || !section) return;

  if (id) {
    const prev = ScrollTrigger.getById(id);
    prev?.kill();
  }

  ScrollTrigger.create({
    id,
    trigger: section,
    start: () => `top top-=${section.offsetHeight * 0.05}`,
    end: "bottom top",
    pin: pinSelector,
    pinSpacing,
    markers,
    anticipatePin: 1,
    invalidateOnRefresh: true,
  });
};

/**
 * ── 背景などの自動pin ──
 * data属性優先。BEMの block 推測は p-/c- 始まりのみ許可して誤検出を抑制
 * data-section / data-container / data-pin を付ければ確実です。
 */
function autoInitPinnedSections({
  defaultMarkers = false,
  defaultPinSpacing = false,
} = {}) {
  document.querySelectorAll(".js-pin-section").forEach((sectionEl, idx) => {

    const block =
      [...sectionEl.classList].find((c) => /^(p|c)-[a-z0-9-]+$/.test(c)) || "";

    const sectionSelector   =
      sectionEl.dataset.section   || (block ? `.${block}` : "");
    const containerSelector =
      sectionEl.dataset.container || (block ? `.${block}__container` : "");
    const pinSelector       =
      sectionEl.dataset.pin       || (block ? `.${block}__pin-bg` : "");

    const markers =
      sectionEl.dataset.markers    ? sectionEl.dataset.markers === "true"    : defaultMarkers;
    const pinSpacing =
      sectionEl.dataset.pinSpacing ? sectionEl.dataset.pinSpacing === "true" : defaultPinSpacing;

    if (sectionSelector && containerSelector && pinSelector) {

      const id = sectionEl.id || `auto-pin-${idx}`;
      setupPinnedSection(sectionSelector, containerSelector, pinSelector, {
        markers,
        pinSpacing,
        id,
      });
    }
  });
}

window.addEventListener("DOMContentLoaded", () => {
  autoInitPinnedSections({
    defaultMarkers: false,
    defaultPinSpacing: false,
  });
});

const debouncedRefresh = (() => {
  let t = 0;
  return () => {
    clearTimeout(t);
    t = setTimeout(() => ScrollTrigger.refresh(), 120);
  };
})();

window.addEventListener("load",   () => ScrollTrigger.refresh());
window.addEventListener("resize", debouncedRefresh);

/* ────────────────────────────────────────────────────────────
   p-about-value 見出しpin（769px以上のみ）
──────────────────────────────────────────────────────────── */
const SELECTORS = {
  section: ".p-about-value",
  container: ".p-about-value__container",
  head: ".p-about-value__head",
  list: ".p-about-value__list",
};

const q = (sel) => document.querySelector(sel);

function createHeadPin() {
  if (!q(SELECTORS.section) || !q(SELECTORS.container) || !q(SELECTORS.head) || !q(SELECTORS.list)) return;

  const ID = "about-value-head-pin";
  ScrollTrigger.getById(ID)?.kill();

  ScrollTrigger.create({
    id: ID,
    trigger: SELECTORS.container,
    start: "top 30%+=1",
    endTrigger: SELECTORS.list,
    end: "bottom 40%",
    pin: SELECTORS.head,
    pinSpacing: false,
    pinReparent: true,
    anticipatePin: 1,
    invalidateOnRefresh: true,
    pinType: ScrollTrigger.isTouch ? "transform" : "fixed",
  });
}

document.addEventListener("DOMContentLoaded", () => {
  ScrollTrigger.matchMedia({
    "(min-width: 769px)": () => {
      createHeadPin();

      requestAnimationFrame(() => setTimeout(() => ScrollTrigger.refresh(), 0));
      document.fonts?.ready?.then(() => ScrollTrigger.refresh());
    },
  });
});
